export const DATA_MANAGEMENT_APP_FLAGS = {
// No flags currently used in data_management app
};
